import React from "react";

import Form from "./form";

import { connect } from "react-redux";
import {
    getFormSuccess,
    getFormError,
    getVariableState,
    formReset,
} from "../../../../../redux/actions/manager/stat/evolution";

import { loadCache, isCacheLoading, isCacheLoaded } from "../../../../../redux/actions/cache/interface";

import { isNotValid, translateSymfonyErrorToFormik } from "../../../../../core/utils/form";

class Container extends React.Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        this.props.loadCache();
    }

    componentWillUnmount() {
        this.props.formReset();
    }

    /**
     * Función que maneja el submit del formulario
     *
     * Recordar que se puede tratar de un alta o una edición
     */
    _handleSubmit = (values, bag) => {
        const form = { ...values, ...this.props.periodListQuery };

        const ret = this.props.getVariableState(JSON.stringify(form));

        ret.then((response) => {
            if (isNotValid(response)) {
                bag.setErrors(translateSymfonyErrorToFormik(response.errors.children));
                bag.setSubmitting(false);
            } else {
                if (this.props.success) {
                    this.props.updateData(response);
                    this.props.handleCancel();
                } else {
                    bag.setSubmitting(false);
                }
            }
        }).catch((e) => {
            bag.setSubmitting(false);
        });
    };

    render() {
        return (
            <Form
                loading={this.props.loading}
                visible={this.props.visible}
                initialValues={this.props.initialValues}
                handleSubmit={this._handleSubmit}
                handleCancel={this.props.handleCancel}
                {...this.props}
            />
        );
    }
}

const cacheList = [];

function MapStateToProps(state) {
    return {
        error: getFormError(state),
        success: getFormSuccess(state),

        loaded: isCacheLoaded(state, cacheList),
        loading: isCacheLoading(state, cacheList),
    };
}

const mapDispatchToProps = (dispatch) => {
    return {
        loadCache: () => loadCache(cacheList)(dispatch),

        formReset: () => dispatch(formReset()),
        getVariableState: (form) => dispatch(getVariableState(form)),
    };
};

export default connect(MapStateToProps, mapDispatchToProps)(Container);
